<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            template(v-if="!isLoading")
                find-opponent(v-if="!opponent", :status="status", :is-training="isTraining", @cancelInvite="cancelInvite")
                opponent(
                    v-else,
                    :status="status",
                    :decline-type="declineType"
                    :opponent="opponent",
                    :is-training="isTraining"
                    @cancelInvite="cancelInvite"
                    @startBattle="startBattle"
                )
            cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import BattleApi from '../../../api/battle';
    import { mapState } from 'vuex';

    import FindOpponent from './FindOpponent.vue';
    import Opponent from './Opponent.vue';
    import _ from 'lodash';

    import {
        INVITATION_ACCEPTED_STATUS,
        INVITATION_DECLINED_STATUS,
        INVITATION_SENT_STATUS,
    } from '../../../config/battle';

    const BLOCKED_ROUTES_FOR_BATTLE_PAUSE = ['battles:opponents', 'battle:start', 'battles-training:opponents'];

    export default {
        props: {
            battleId: {
                type: [Number, String],
                default: null,
            },
            isTraining: {
                type: Boolean,
                default: false,
            },
            opponentId: {
                type: [Number, String],
                default: null,
            },
        },
        beforeRouteLeave(to, from, next) {
            this.$store.dispatch('setBattleDeclined', false);
            this.$store.dispatch('setBattleAccepted', false);
            if (this.status === INVITATION_SENT_STATUS) {
                this.cancelInvite();
            }
            if (!BLOCKED_ROUTES_FOR_BATTLE_PAUSE.includes(to.name)) {
                this.pauseBattle();
            }
            next();
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            if (this.user.type !== 'student') {
                this.$toasted.info(this.$i18n.t('errors.only_for_students'));
                this.$router.back();
                return;
            }
            if (!this.battleId) {
                this.$router.back();
                return;
            }
            if (!this.isInvitationDeclined) {
                this.findOpponent();
            }
            this.$echo.private(`cancel-battle-invite.${this.user.id}`).listen('BattleCancelInvite', data => {
                if (data.status === INVITATION_SENT_STATUS && data.declineFrom === 'sender') {
                    this.status = INVITATION_DECLINED_STATUS;
                }
                this.declineType = data.declineType;
            });
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        watch: {
            isInvitationDeclined(value) {
                if (this.opponent) {
                    this.status = value ? INVITATION_DECLINED_STATUS : 'searching_for_opponent';
                }
            },
            isBattleAccepted(value) {
                if (value) {
                    this.status = INVITATION_ACCEPTED_STATUS;
                }
            },
        },
        data() {
            return {
                opponent: null,
                status: 'searching_for_opponent',
                existingBattleId: null,
                isLoading: false,
                declineType: '',
            };
        },
        methods: {
            cancelInvite(withoutTransition = true) {
                this.isLoading = true;
                this.status = INVITATION_DECLINED_STATUS;
                BattleApi.cancelInvite({ declineFrom: 'sender' })
                    .then(() => {
                        if (!withoutTransition) {
                            this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
                        }
                    })
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            findOpponent() {
                this.status = 'searching_for_opponent';
                this.opponent = null;
                BattleApi.inviteOpponent({
                    battleId: this.battleId,
                    opponentId: this.opponentId,
                    course_type: _.kebabCase(this.course),
                })
                    .then(data => {
                        this.status = data.status;
                        if (this.status === 'wait_or_cancel_previous_invite') {
                            this.existingBattleId = data.battleId;
                        }
                        if (data.status === 'no_opponents') {
                            this.$toasted.info(this.$i18n.t('battle.battle_no_opponents'));
                        }
                        this.opponent = data.opponent;
                    })
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                    });
            },
            beforeTabClosed() {
                if (this.status === INVITATION_SENT_STATUS) {
                    this.cancelInvite();
                }
                this.pauseBattle();
                return null;
            },
            startBattle() {
                this.$router.push({ name: 'battle:start', params: { id: this.battleId, opponent: this.opponent } });
            },
            pauseBattle() {
                BattleApi.pauseBattle({ stage_index: 0, game_index: 0 })
                    .then()
                    .catch(err => {
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                    });
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                isInvitationDeclined: state => state.battle.isInvitationDeclined,
                isBattleAccepted: state => state.battle.isBattleAccepted,
                prevRoute: state => state.router.previousRoute,
                course: state => state.trainer.course,
            }),
        },
        components: {
            FindOpponent,
            Opponent,
        },
    };
</script>

<style scoped lang="scss">
    .box {
        box-sizing: border-box;
        width: 100%;
        border-radius: 40px;
        background: #ffffff;
        box-shadow: 0 0 54px #51a552;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        @media screen and (max-width: 575px) {
            border-radius: 0;
            height: 100vh;
            box-shadow: none;
            padding: 0;
        }
    }
    .box-body {
        width: 100%;
        height: 100%;
    }
</style>
